var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Tooltip"},[_c('div',{staticClass:"Tooltip__content",class:[this.positionClass, this.slotClass],attrs:{"data-tooltip":_vm.text}},[(!this.$slots.default)?_c('span',[_vm._v("?")]):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.text))])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5eac0045","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tooltip/tooltip.vue
// module id = null
// module chunks = 